module.exports = __webpack_public_path__ + "img/icon-checkmark-filled.e1d28985.svg";